import axios from 'axios'
import { defaultRequestInterceptor, defaultResponseInterceptor, defaultErrorInterceptor } from './axiosHelpers'

const instance = axios.create({
    withCredentials: true,
    baseURL: process.env.NEXT_PUBLIC_API_URL,
})

instance.interceptors.request.use(defaultRequestInterceptor, (error) => Promise.reject(error))

instance.interceptors.response.use(defaultResponseInterceptor, defaultErrorInterceptor)

export default instance
